import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "details-page" }
const _hoisted_2 = { class: "details-page__header" }
const _hoisted_3 = { class: "details-page__header-content" }
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { class: "details-page__content" }
const _hoisted_6 = {
  key: 0,
  class: "details-page__comments"
}
const _hoisted_7 = { class: "details-page__misc" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["innerHTML"]

import { computed, ComputedRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from "@/stores/store";
import { useUtil } from "@/services/util-service";
import { ISearchResultItem } from 'interfaces/search/ISearchResultItem';
import ShipDetails from './ShipDetails.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();

const shipId = route.params.shipId;
const ship: ComputedRef<ISearchResultItem> = computed(() => store.originalSearchResult?.results.find((ship: any) => ship.uuid === shipId));

const exportToExcel = () => {
  let array: ISearchResultItem[] = [ship.value];
  useUtil().exportToExcel(array);
}

const autoLink = (text: string): string => {
  const urlRegex = /((https?:\/\/)?(www\.)?[^\s]+\.[^\s]{2,})([.,;!?)]*)/gi
  return text.replace(urlRegex, (_, url, _protocol, _www, trailing) => {
    const fullUrl = url.startsWith('http') ? url : `https://${url}`
    return `<a href="${fullUrl}" target="_blank" rel="noopener">${url}</a>${trailing}`
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "icon icon--arrow-left" }, null, -1 /* HOISTED */),
          _createTextVNode(" Tillbaka ")
        ])),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(ship.value?.name), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (exportToExcel())),
        class: "button"
      }, _cache[3] || (_cache[3] = [
        _createTextVNode(" Ladda ned "),
        _createElementVNode("span", { class: "icon icon--download" }, null, -1 /* HOISTED */)
      ])),
      _createVNode(ShipDetails, { ship: ship.value }, null, 8 /* PROPS */, ["ship"]),
      (ship.value?.comments)
        ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "details-page__section-title" }, "Kommentar", -1 /* HOISTED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ship.value?.comments, (comment, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: `comment-${i}`
              }, _toDisplayString(comment), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("section", _hoisted_7, [
        (ship.value?.webReferences)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "details-page__section-title" }, "Länkar", -1 /* HOISTED */)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ship.value?.webReferences, (webReference, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `webReference-${i}`,
                    innerHTML: autoLink(webReference)
                  }, null, 8 /* PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (ship.value?.references)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "details-page__section-title" }, "Referens", -1 /* HOISTED */)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ship.value?.references, (reference, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `reference-${i}`,
                    innerHTML: autoLink(reference)
                  }, null, 8 /* PROPS */, _hoisted_11))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})